import {Component, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';
import {EMPTY_FAVORITE, EMPTY_USER, EVOL_DEMO_LAST_YEAR, PRICE_EVOL_LEGENT} from '@models/empty';
import {User} from '@models/user';
import {environment} from '~/environments/environment';
import {CityService} from '@services/city.service';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {AdService} from '@services/ad.service';
import {AuthenticationService} from '@services/authentification.service';
import {AlertService} from '@services/alert.service';
import * as htmlToImage from 'html-to-image';
import {jsPDF} from 'jspdf';
import {PdfConfig} from '@models/pdf';
import * as _ from 'underscore';
import {UserService} from '@services/user.service';
import {UpgradePlanV2Component} from '@components/popup/upgrade-plan-v2/upgrade-plan-v2.component';
import {TrackingService} from '@services/tracking.service';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'app-oikos',
    templateUrl: './oikos.component.html',
    styleUrls: ['./oikos.component.scss']
})
export class OikosComponent implements OnInit {

    favorite: Favorite = Object.assign({}, EMPTY_FAVORITE);
    user: User = Object.assign({}, EMPTY_USER);
    pdfConfig: PdfConfig;

    params;
    result: any[] = [];
    result25: any[] = [];
    displayedColumns: string[] = [];
    amort_moy = 0;
    amort_moy25 = 0;
    apiUrl = environment.apiUrl;
    hideUnit = false;
    imgDone: string[] = [];
    imgAnnonce = '';
    imgSecteur = '';
    imgSecteurBis = '';
    imgAnalyse = '';
    imgVideo = '';
    imgPhoto1 = '';
    imgPhoto2 = '';
    imgPhoto3 = '';
    imgPhoto4 = '';
    imgPhoto5 = '';
    imgPhoto6 = '';
    imgWork = '';
    imgFinance = '';
    imgFinance_25 = '';
    imgFinance2 = '';
    imgFinance3 = '';
    imgFinance3_25 = '';

    ready = false;
    loading = false;
    nbPictures_1 = 0;
    nbPictures_2 = 0;
    nbPictures_3 = 0;
    nbPictures_4 = 0;
    nbPictures_5 = 0;
    nbPictures_6 = 0;

    advice_price = 0;
    monthly25 = 0;
    efficiency_brut = 0;

    rand = Math.floor(Date.now() / 1000);
    /**
     * Chart repartition
     */
    chargeEchartsIntance = null;
    chargeOptions = {
        tooltip: {
            trigger: 'item',
            formatter: '{c}€ ({d}%)'
        },
        legend: {
            orient: 'vertical',
            right: '30px',
            top: '30px',
            align: 'right',
            textStyle: {
                fontSize: 18,
            },

        },
        calculable: true,
    };
    chargeData = {
        series: []
    };

    /**
     * Chart price evol
     */
    priceEvolEchartsIntance = null;
    priceEvolOptions = {
        legend: {
            orient: 'vertical',
            right: '20px',
            bottom: '40px',
            align: 'right',
        },
        grid: {
            left: '1%',
            right: '3%',
            top: '10',
            bottom: '15',
            containLabel: true,
        },
        xAxis: {
            data: [],
            axisLabel: {
                fontSize: 12
            }
        },

        yAxis: {
            type: 'value',
            label: {
                formatter: '{b} <br/>{a} : {c} €/m²',
            },
            min: 10000,
            axisLabel: {
                formatter: '{value} €/m²',
                fontSize: 12
            }
        },
        color: ['#275458', '#ED6F40'],
        series: []
    };
    priceEvolData = {
        series: [],
    };

    /**
     * Chart prix
     */
    priceEchartsIntance = null;
    priceOptions = {
        label: {
            show: true,
            position: 'insideRight',
            color: 'white',
            fontSize: 16,
            formatter: d => {
                return d.data > 0 ? parseFloat(d.data).toLocaleString('fr-FR', {
                    style: 'currency',
                    currency: 'EUR'
                }) + '/m²' : '';
            }
        },
        grid: {
            left: '1%',
            right: '3%',
            top: '0',
            bottom: '15',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            max: 1,
        },
        yAxis: {
            type: 'category',
            data: [],
            axisLabel: {
                fontSize: 12
            }
        },

        color: ['#54b0ed', '#1277AA'],
        series: []
    };
    priceData = {
        series: [],
    };

    /**
     * Chart Loyer
     */
    rentEchartsIntance = null;
    rentOptions = {
        label: {
            show: true,
            position: 'insideRight',
            color: 'white',
            fontSize: 16,
            formatter: d => {
                return d.data > 0 ? parseFloat(d.data).toLocaleString('fr-FR', {
                    style: 'currency',
                    currency: 'EUR'
                }) + '/m²' : '';
            }
        },
        grid: {
            left: '1%',
            right: '3%',
            top: '0',
            bottom: '15',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            max: 1,
        },
        yAxis: {
            type: 'category',
            data: [],
            axisLabel: {
                fontSize: 12
            }
        },

        color: ['#275458', '#ED6F40'],
        series: []
    };
    rentData = {
        series: [],
    };

    // Graphique Evolution du capital net
    capitalEchartsIntance = null;
    options_Evol_Capital = {
        tooltip: {
            trigger: 'item',
            formatter: params => {
                let lib = 'Année ' + params.name + ' <br/>' + '<span style="font-size:24px; color: ' + params.color + '">• </span>' + params.seriesName + ' : ' + params.value + '€';
                return lib;
            },
        },
        legend: {},
        xAxis: [
            {
                type: 'category',
                name: 'Année',
                nameLocation: 'center',
                nameTextStyle: {
                    align: 'center',
                    lineHeight: 50,
                    fontWeight: 'bold',
                    fontSize: 16
                },
                axisLabel: {
                    fontSize: 16,
                },
                data: []
            }
        ],

        yAxis: [
            {
                type: 'value',
                axisLabel: {
                    formatter: '{value} €',
                    fontSize: 16,
                }
            },
        ],
        series: []
    };
    options_Evol_Capital25 = {
        tooltip: {
            trigger: 'item',
            formatter: params => {
                let lib = 'Année ' + params.name + ' <br/>' + '<span style="font-size:24px; color: ' + params.color + '">• </span>' + params.seriesName + ' : ' + params.value + '€';
                return lib;
            },
        },
        legend: {},
        xAxis: [
            {
                type: 'category',
                name: 'Année',
                nameLocation: 'center',
                nameTextStyle: {
                    align: 'center',
                    lineHeight: 50,
                    fontWeight: 'bold',
                    fontSize: 16
                },
                axisLabel: {
                    fontSize: 16,
                },
                data: []
            }
        ],

        yAxis: [
            {
                type: 'value',
                axisLabel: {
                    formatter: '{value} €',
                    fontSize: 16,
                }
            },
        ],
        series: []
    };
    capitalData = {
        series: [],
    };
    capitalData25 = {
        series: [],
    };

    // Graphique évolution du cash flow
    cashflowEchartsIntance = null;
    optionsCF = {
        tooltip: {
            trigger: 'item',
            formatter: params => {
                return 'Année ' + params.name + ' <br/>' + '<span style="font-size:24px; color: ' + params.color + '">• </span>' + params.seriesName + ' : ' + params.value + '€';
            },
            axisPointer: {
                type: 'cross',
                crossStyle: {
                    color: '#999'
                }
            }
        },
        legend: {},
        xAxis: [
            {
                type: 'category',
                name: 'Année',
                nameLocation: 'center',
                nameTextStyle: {
                    align: 'center',
                    lineHeight: 50,
                    fontWeight: 'bold',
                    fontSize: 15
                },
                data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
                axisPointer: {}
            }
        ],
        yAxis: [
            {
                type: 'value',
                // name: 'Loyers et charges',
                axisLabel: {
                    formatter: '{value} €'
                }
            },
        ],
        series: []
    };
    cashflowData = {
        series: [],
    };
    cashflowData25 = {
        series: [],
    };

    // Entreprise
    entrepriseEvolEchartsIntance = null;
    entrepriseEvolOptions = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                animation: false
            },
            formatter: params => {
                let lib = params[0].name + '<br/>';
                params.forEach(d => {
                    lib += '<span style="font-size:24px;">• </span>' + d.seriesName + ' : ' + Math.round(d.data).toLocaleString('fr-FR');
                });
                return lib;
            }
        },
        legend: {
            orient: 'vertical',
            right: '40px',
            bottom: '70px',
            align: 'right',
        },
        grid: {
            left: '0%',
            right: '1%',
            top: '40px',
            bottom: '15',
            containLabel: true
        },
        xAxis: {
            data: [],
            axisTick: {
                alignWithLabel: true,
            },
        },

        yAxis: {
            type: 'value',
            label: {
                formatter: '{b} <br/>{a} : {c}',
            },
            min: 10000,
        },
        color: ['#275458'],

    };
    entrepriseEvolData = {
        series: [],
    };

    // Habitants
    habitantEvolEchartsIntance = null;
    habitantEvolOptions = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: '{a} <br/>{b} : {c}'
        },
        grid: [{
            left: '0',
            right: '10px',
            top: '10px',
            bottom: '20px',
            containLabel: true
        }],
        xAxis: {
            type: 'category',
            data: [],
            axisTick: {
                alignWithLabel: true,
            },
        },

        yAxis: {
            type: 'value',
            min: 1000000,
        },
        color: ['#275458'],

        series: []

    };
    habitantEvolData = {
        series: [],
    };

    // Contact
    pro_data = {
        mobile: '',
    };

    constructor(
        public cityService: CityService,
        private http: HttpClient,
        private route: ActivatedRoute,
        private adService: AdService,
        private userService: UserService,
        public trackingService: TrackingService,
        public dialog: MatDialog,
        public authenticationService: AuthenticationService,
        private alertService: AlertService,
        private router: Router) {
    }

    ngOnInit(): void {
        this.pdfConfig = {
            societe: 'Oikos',
            template: ['classique'],
            logo_w: 517,
            logo_h: 124,
            logo_url: 'assets/pdf/oikos/oikos-logo.png',
            logo_small_w: 517,
            logo_small_h: 124,
            logo_small_url: 'assets/pdf/oikos/oikos-logo.png',
            logo_small_style: '',
            display_legal_notice: true,
            display_note: false,
            display_contact: true,
            contact_tpl: 'text',
            contact_visuel: '',
            contact: `
                        <p class="text-center">Oikos – 1 avenue Wilson, 11200 LÉZIGNAN-CORBIÈRES<br/>
                        Pour toutes questions sur le projet vous pouvez contacter l’équipe client par mail :<br/>
                        contact@oikos-immo.com</p>`,
            contact_bkg: '#ED6F40',
            h2_class: 'underline',
            h2_underline_url: '',
            h3_class: '',
            font_family: 'Gotham',
            text_color: '#000000',
            second_color: '#ED6F40',
            visuel_1: '',
            visuel_1b: '',
            visuel_2: '',
            visuel_3: '',
            color_kpi_1: '#275458',
            color_kpi_2: '#275458',
            color_kpi_3: '#275458',
            color_kpi_4: '#275458',
            color_kpi_5: '#275458',
            marque_blanche: false,
        };

        let css = `
                #book * {
                    font-family: '` + this.pdfConfig.font_family + `-Regular';
                    color: ` + this.pdfConfig.text_color + `;
                }
                #book .contact * {
                    color: white;
                }
                #book .text-blue {
                    color: ` + this.pdfConfig.text_color + ` !important;
                }
                #book .title {
                    font-family: '` + this.pdfConfig.font_family + `-Medium';
                    color: ` + this.pdfConfig.text_color + `;
                }
                #book h2 {
                    font-family: '` + this.pdfConfig.font_family + `-Medium';
                }
                #book .card .card-header .card-title h3 {
                    font-family: '` + this.pdfConfig.font_family + `-Regular';
                }
                #book .block.card label {
                    font-family: "` + this.pdfConfig.font_family + `-Regular";
                }
                #book .block_recap table td {
                    font-family: "` + this.pdfConfig.font_family + `-Light";
                }
                #book .block_recap table th, #book .block_recap table th > div, #book .block_recap table th > div > span {
                    font-family: "` + this.pdfConfig.font_family + `-Regular";
                }
                #book .desc, #book .desc textarea {
                    font-family: "` + this.pdfConfig.font_family + `-Light";
                }
                #book .notes, #book .notes textarea {
                    font-family: "` + this.pdfConfig.font_family + `-Light";
                }
                #book .contact {
                    background-color: ` + this.pdfConfig.contact_bkg + `;
                }
                #book .contact .col-md-6 {
                    font-family: "` + this.pdfConfig.font_family + `-Light";
                }
                #book .contact .col-md-6 b {
                    font-family: "` + this.pdfConfig.font_family + `-SemiBold";
                }
                #book h2.underline::after {
                    border-color: ` + this.pdfConfig.second_color + ` !important;
                }
                .kpi-color-1 {
                    background-color: ` + this.pdfConfig.color_kpi_1 + `;
                }
                .kpi-color-2 {
                    background-color: ` + this.pdfConfig.color_kpi_2 + `;
                }
                .kpi-color-3 {
                    background-color: ` + this.pdfConfig.color_kpi_3 + `;
                }
                .kpi-color-4 {
                    background-color: ` + this.pdfConfig.color_kpi_4 + `;
                }
                .kpi-color-5 {
                    background-color: ` + this.pdfConfig.color_kpi_5 + `;
                }
                .kpi-color-green {
                    background-color: #76D958;
                }
            `;

        css += `
                    #book .title {
                        color: ` + this.pdfConfig.second_color + ` !important;
                    }
                    #book h3.text-blue {
                        color: ` + this.pdfConfig.second_color + ` !important;
                    }
                    .adress, .click {
                        color: ` + this.pdfConfig.second_color + ` !important;
                    }
                    .page {
                        border-left: 60px solid ` + this.pdfConfig.second_color + `;
                    }
                    .card-border {
                        border: 6px solid ` + this.pdfConfig.second_color + ` !important;
                        border-radius: 10px !important;
                    }
                    .page b, .page h2, .page .text-green, .page table th {
                        color: #275458 !important;
                    }
                    .kpi-color-10 {
                        background-color: ` + this.pdfConfig.second_color + `;
                    }
                `;
        const head = document.getElementsByTagName('head')[0];
        const style = document.createElement('style');
        style.type = 'text/css';
        style.appendChild(document.createTextNode(css));
        head.appendChild(style);

        this.user = this.authenticationService.currentUser;
        if (this.user.pro_plan !== '' && this.user.pro_data !== '') {
            this.pro_data = JSON.parse(this.user.pro_data);
        }
        if (this.user.user_dashboard.pdf_page == null || this.user.user_dashboard.pdf_page.includes('patrimoniale')) {
            // Secure for "normal" pdf settings
            this.user.user_dashboard.pdf_page = [];
        }

        this.route.parent.params.subscribe(params => {
            this.params = params;

            // Source de vérité unique : on réutilise le favori déjà chargé et mis en
            // cache par le composant parent (detail-wrap), au lieu de refaire un GET.
            // Un GET séparé créait un 2e objet favori : les modifications saisies ici
            // étaient ensuite écrasées par le PUT complet des onglets du dossier (et
            // les modifications du dossier n'étaient pas vues ici tant que le PUT
            // debouncé n'était pas parti).
            const fetch$ = this.adService.getCacheFavorite();
            fetch$.subscribe(result => {
                this.favorite = this.adService.updateValues(result);

                // Demande oikos Loyers HC annuels / Prix d’achat + Honoraires Oikos + Travaux + Maitrise d’oeuvre Oikos
                const total_price = this.favorite.price + this.favorite.other_fees + this.favorite.other_fees_work + this.favorite.works_total + this.favorite.works_not_deduc + this.favorite.furniture_price;
                this.efficiency_brut = (this.favorite.amount_rent * 12) * 100 / total_price;

                if (this.favorite.pictures_number == '') {
                    if (this.favorite.pictures.length > 6) {
                        this.nbPictures_1 = 6;
                        if (this.favorite.pictures.length > 12) {
                            this.nbPictures_2 = 6;
                            if (this.favorite.pictures.length > 18) {
                                this.nbPictures_3 = 6;
                                if (this.favorite.pictures.length > 24) {
                                    this.nbPictures_4 = 6;
                                    if (this.favorite.pictures.length > 30) {
                                        this.nbPictures_5 = 6;
                                        this.nbPictures_6 = this.favorite.pictures.length - 30;
                                    } else {
                                        this.nbPictures_5 = this.favorite.pictures.length - 24;
                                    }
                                } else {
                                    this.nbPictures_4 = this.favorite.pictures.length - 18;
                                }
                            } else {
                                this.nbPictures_3 = this.favorite.pictures.length - 12;
                            }
                        } else {
                            this.nbPictures_2 = this.favorite.pictures.length - 6;
                        }
                    } else {
                        this.nbPictures_1 = this.favorite.pictures.length;
                    }
                } else {
                    var ex = this.favorite.pictures_number.split(';');
                    if (ex[0]) {
                        this.nbPictures_1 = parseInt(ex[0]);
                    }
                    if (ex[1]) {
                        this.nbPictures_2 = parseInt(ex[1]);
                    }
                    if (ex[2]) {
                        this.nbPictures_3 = parseInt(ex[2]);
                    }
                    if (ex[3]) {
                        this.nbPictures_4 = parseInt(ex[3]);
                    }
                    if (ex[4]) {
                        this.nbPictures_5 = parseInt(ex[4]);
                    }
                    if (ex[5]) {
                        this.nbPictures_6 = parseInt(ex[5]);
                    }
                }

                this.setRentData(this.favorite.furnish);
                this.setPriceData(this.favorite.estate_type);
                this.setPriceEvolData();
                this.setChargeData();
                this.setEntrepriseEvolData();
                this.setHabitantEvolData();
                this.callImpot();

                this.advice_price = this.favorite.advice_price;
            }, error => {
                if (error != 'token_outdate') {
                    this.alertService.error('Favoris introuvable', true);
                    this.router.navigate(['/app/favorites', params.id]);
                }
            });
        });
    }

    createPdf() {
        if (!this.authenticationService.isAllowed('expert')) {

            this.trackingService.click('pdf_upgrade_open', '');
            const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                width: '520px',
                data: {visuel: 'assets/export_1.png', plan: 'Expert', feature: 'Dossier bancaire'}
            });
            this.authenticationService.currentUser.user_onboarding.popup_search_fav = true;
            this.userService.updateOnboarding(this.authenticationService.currentUser);

            dialogRef.afterClosed().subscribe(result => {
                if (result === true) {
                    this.trackingService.click('pdf_upgrade_valid', '');
                } else {
                    this.trackingService.click('pdf_upgrade_cancel', '');
                }
            });
            return;
        }
        this.loading = true;

        function filter(node) {
            return (node.className !== 'logo');
            // return (node.className !== 'logo' && node.className !== 'input_title');
        }

        var scale = 1;
        if (this.user.user_dashboard.pdf_quality == 'hd') {
            scale = 2;
        }
        var offsetWidth = 1339.38;
        var offsetHeight = 1894.2525;
        if (this.user.user_dashboard.pdf_page.includes('annonce')) {
            htmlToImage.toPng(document.getElementById('annonce') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgAnnonce = dataUrl;
                    // window.open(dataUrl, '_blank');
                    this.imgDone.push('annonce');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('secteur')) {
            htmlToImage.toPng(document.getElementById('secteur') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgSecteur = dataUrl;
                    this.imgDone.push('secteur');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('secteur_bis')) {
            htmlToImage.toPng(document.getElementById('secteur_bis') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgSecteurBis = dataUrl;
                    this.imgDone.push('secteur_bis');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('analyse')) {
            htmlToImage.toPng(document.getElementById('analyse') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgAnalyse = dataUrl;
                    this.imgDone.push('analyse');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('video')) {
            htmlToImage.toPng(document.getElementById('video') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgVideo = dataUrl;
                    this.imgDone.push('video');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('photo_1')) {
            htmlToImage.toPng(document.getElementById('photo_1') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgPhoto1 = dataUrl;
                    this.imgDone.push('photo_1');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('photo_2')) {
            htmlToImage.toPng(document.getElementById('photo_2') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgPhoto2 = dataUrl;
                    this.imgDone.push('photo_2');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('photo_3')) {
            htmlToImage.toPng(document.getElementById('photo_3') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgPhoto3 = dataUrl;
                    this.imgDone.push('photo_3');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('photo_4')) {
            htmlToImage.toPng(document.getElementById('photo_4') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgPhoto4 = dataUrl;
                    this.imgDone.push('photo_4');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('photo_5')) {
            htmlToImage.toPng(document.getElementById('photo_5') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgPhoto5 = dataUrl;
                    this.imgDone.push('photo_5');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('photo_6')) {
            htmlToImage.toPng(document.getElementById('photo_6') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgPhoto6 = dataUrl;
                    this.imgDone.push('photo_6');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('work')) {
            htmlToImage.toPng(document.getElementById('work') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgWork = dataUrl;
                    this.imgDone.push('work');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('finance')) {
            htmlToImage.toPng(document.getElementById('finance') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgFinance = dataUrl;
                    this.imgDone.push('finance');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('finance_25')) {
            htmlToImage.toPng(document.getElementById('finance_25') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgFinance_25 = dataUrl;
                    this.imgDone.push('finance_25');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('finance_2')) {
            htmlToImage.toPng(document.getElementById('finance_2') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgFinance2 = dataUrl;
                    this.imgDone.push('finance_2');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('finance_3')) {
            htmlToImage.toPng(document.getElementById('finance_3') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgFinance3 = dataUrl;
                    this.imgDone.push('finance_3');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('finance_3_25')) {
            htmlToImage.toPng(document.getElementById('finance_3_25') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgFinance3_25 = dataUrl;
                    this.imgDone.push('finance_3_25');
                    this.downloadPdf();
                });
        }
    }

    downloadPdf() {
        if (this.imgDone.length == this.user.user_dashboard.pdf_page.length) {

            const pdf = new jsPDF('p', 'px', 'a4');

            const width = pdf.internal.pageSize.getWidth();
            const height = pdf.internal.pageSize.getHeight();

            pdf.addFont('assets/pdf/font/' + this.pdfConfig.font_family + '-SemiBold.ttf', '' + this.pdfConfig.font_family + '-SemiBold', 'normal');
            pdf.setFont('Gilroy-SemiBold');

            if (this.user.user_dashboard.pdf_page.includes('annonce')) {
                pdf.addImage(this.imgAnnonce, 'PNG', 0, 0, width, height, null, 'MEDIUM');

                let height_logo = Math.round(this.pdfConfig.logo_h / 3);
                if (height_logo > 80) {
                    height_logo = 80;
                }
                const with_logo = this.pdfConfig.logo_w / (this.pdfConfig.logo_h / height_logo);
                pdf.addImage(this.pdfConfig.logo_url, 'PNG', (width - with_logo) / 2, 25, with_logo, height_logo);
            }

            // Title (dont take user modification)
            pdf.addFont('assets/pdf/font/' + this.pdfConfig.font_family + '-SemiBold.ttf', '' + this.pdfConfig.font_family + '-SemiBold', 'normal');
            pdf.setFont('' + this.pdfConfig.font_family + '-SemiBold');
            pdf.setTextColor(this.pdfConfig.text_color);
            pdf.setFontSize(8);
            // pdf.setFontSize(22);
            // pdf.text(this.favorite.estate_type + ' | ' + this.favorite.rooms + ' pièces | ' + this.favorite.square + 'm2', 220, 150, {align: 'center'});

            const height_small_logo = 20;
            const with_small_logo = this.pdfConfig.logo_small_w / (this.pdfConfig.logo_small_h / height_small_logo);
            let x = 20;
            if (this.pdfConfig.logo_small_style.includes('center')) {
                x = (width - with_small_logo) / 2;
            }

            let xSmallLogo = width - with_small_logo - 20;
            let ySmallLogo = 10;

            if (this.user.user_dashboard.pdf_page.includes('secteur')) {
                pdf.addPage();
                pdf.addImage(this.imgSecteur, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', xSmallLogo, ySmallLogo, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('secteur_bis')) {
                pdf.addPage();
                pdf.addImage(this.imgSecteurBis, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', xSmallLogo, ySmallLogo, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('analyse')) {
                pdf.addPage();
                pdf.addImage(this.imgAnalyse, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', xSmallLogo, ySmallLogo, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('video')) {
                pdf.addPage();
                pdf.addImage(this.imgVideo, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                // pdf.rect(50, 50, width - 100, height - 100, 'FD');
                if (this.favorite.visite_link) {
                    pdf.link(50, 50, width - 100, height - 100, {url: this.favorite.visite_link});
                }
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', xSmallLogo, ySmallLogo, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('photo_1')) {
                pdf.addPage();
                pdf.addImage(this.imgPhoto1, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', xSmallLogo, ySmallLogo, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('photo_2')) {
                pdf.addPage();
                pdf.addImage(this.imgPhoto2, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', xSmallLogo, ySmallLogo, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('photo_3')) {
                pdf.addPage();
                pdf.addImage(this.imgPhoto3, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', xSmallLogo, ySmallLogo, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('photo_4')) {
                pdf.addPage();
                pdf.addImage(this.imgPhoto4, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', xSmallLogo, ySmallLogo, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('photo_5')) {
                pdf.addPage();
                pdf.addImage(this.imgPhoto5, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', xSmallLogo, ySmallLogo, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('photo_6')) {
                pdf.addPage();
                pdf.addImage(this.imgPhoto6, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', xSmallLogo, ySmallLogo, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('work')) {
                pdf.addPage();
                pdf.addImage(this.imgWork, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', xSmallLogo, ySmallLogo, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('finance')) {
                pdf.addPage();
                pdf.addImage(this.imgFinance, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', xSmallLogo, ySmallLogo, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('finance_25')) {
                pdf.addPage();
                pdf.addImage(this.imgFinance_25, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', xSmallLogo, ySmallLogo, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('finance_2')) {
                pdf.addPage();
                pdf.addImage(this.imgFinance2, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', xSmallLogo, ySmallLogo, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('finance_3')) {
                pdf.addPage();
                pdf.addImage(this.imgFinance3, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', xSmallLogo, ySmallLogo, with_small_logo, height_small_logo);
            }

            if (this.user.user_dashboard.pdf_page.includes('finance_3_25')) {
                pdf.addPage();
                pdf.addImage(this.imgFinance3_25, 'PNG', 0, 0, width, height, null, 'MEDIUM');
                pdf.addImage(this.pdfConfig.logo_small_url, 'PNG', xSmallLogo, ySmallLogo, with_small_logo, height_small_logo);
            }

            pdf.save(this.favorite.title + '.pdf');
            this.http.put(`${environment.apiUrl}app/favorite/${this.favorite.id}/export`, {});

            this.imgAnnonce = '';
            this.imgSecteur = '';
            this.imgSecteurBis = '';
            this.imgAnalyse = '';
            this.imgVideo = '';
            this.imgPhoto1 = '';
            this.imgPhoto2 = '';
            this.imgPhoto3 = '';
            this.imgPhoto4 = '';
            this.imgWork = '';
            this.imgDone = [];
            this.loading = false;
        }
    }

    setRentData(furnish) {
        this.rentOptions.yAxis.data = ['1 pièces / Studio', '2 pièces', '3 pièces', '4 pièces', '5 pièces', 'Appartement', 'Maison', 'Garage / Parking'];

        this.rentOptions.xAxis.max = Math.round([
            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[1] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[1].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[2] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[2].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[3] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[3].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[4] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[4].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[5] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[5].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville.A.lM,
            this.favorite.ad_city.loyer_moyen_ville.M.lM,
            this.favorite.ad_city.loyer_moyen_ville.P.lM,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[1] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[1].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[2] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[2].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[3] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[3].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[4] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[4].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[5] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[5].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_meuble.A.lM,
            this.favorite.ad_city.loyer_moyen_ville_meuble.M.lM,
            this.favorite.ad_city.loyer_moyen_ville.P.lM,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[1] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[1].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[2] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[2].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[3] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[3].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[4] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[4].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[5] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[5].lM : 0,
            this.favorite.ad_city.loyer_moyen_ville_non_meuble.A.lM,
            this.favorite.ad_city.loyer_moyen_ville_non_meuble.M.lM,
            this.favorite.ad_city.loyer_moyen_ville.P.lM,
        ].sort((a, b) => b - a)[0] / 1);

        if (furnish === 0) {
            this.rentData = {
                series: [
                    {
                        name: this.favorite.ad_city.name,
                        type: 'bar',
                        stack: '1',
                        data: [
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[1] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[1].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[2] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[2].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[3] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[3].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[4] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[4].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece && this.favorite.ad_city.loyer_moyen_ville_nb_piece[5] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece[5].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville.A.lM,
                            this.favorite.ad_city.loyer_moyen_ville.M.lM,
                            this.favorite.ad_city.loyer_moyen_ville.P.lM.toPrecision(3),
                            0,
                        ]
                    },
                ]
            };
        } else if (furnish === 1) {
            this.rentData = {
                series: [
                    {
                        name: this.favorite.ad_city.name,
                        type: 'bar',
                        stack: '1',
                        data: [
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[1] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[1].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[2] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[2].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[3] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[3].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[4] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[4].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[5] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble[5].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_meuble.A.lM,
                            this.favorite.ad_city.loyer_moyen_ville_meuble.M.lM,
                            this.favorite.ad_city.loyer_moyen_ville.P.lM.toPrecision(3),
                            0,
                        ]
                    },
                ]
            };
        } else if (furnish === 2) {
            this.rentData = {
                series: [
                    {
                        name: this.favorite.ad_city.name,
                        type: 'bar',
                        stack: '1',
                        data: [
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[1] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[1].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[2] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[2].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[3] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[3].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[4] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[4].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble && this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[5] ? this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble[5].lM.toPrecision(3) : null,
                            this.favorite.ad_city.loyer_moyen_ville_non_meuble.A.lM,
                            this.favorite.ad_city.loyer_moyen_ville_non_meuble.M.lM,
                            this.favorite.ad_city.loyer_moyen_ville.P.lM.toPrecision(3),
                            0,
                        ]
                    },
                ]
            };
        }

        if (this.favorite.id !== '') {
            this.rentOptions.yAxis.data.push('Votre projet');
            this.rentData.series.push(
                {
                    name: 'Votre projet',
                    type: 'bar',
                    stack: '1',
                    data: [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0, // One more for the city below
                        this.favorite.square > 0 ? (this.favorite.amount_rent / this.favorite.square).toPrecision(3) : 0,
                    ]
                });
        }

        if (this.favorite.ad_city.loyer_moyen_ville.A.lM > 0 || this.favorite.ad_city.loyer_moyen_ville.M.lM > 0) {
            this.rentOptions.yAxis.data = [this.favorite.ad_city.name].concat(this.rentOptions.yAxis.data);
            this.rentData.series[0].data = [this.favorite.ad_city.loyer_moyen_petite_ville.lM.toPrecision(3)].concat(this.rentData.series[0].data);
        } else {
            this.rentOptions.yAxis.data = [this.favorite.ad_city.zip_code].concat(this.rentOptions.yAxis.data);
            this.rentData.series[0].data = [this.favorite.ad_city.loyer_moyen_petite_ville_cp.lM].concat(this.rentData.series[0].data);
        }

        if (this.rentEchartsIntance) {
            this.rentEchartsIntance.setOption(this.rentOptions);
        }
    }

    setPriceData(estateType) {
        this.priceOptions.yAxis.data = ['1 pièces / Studio', '2 pièces', '3 pièces', '4 pièces', '5 pièces', 'Appartement', 'Maison'];

        this.priceOptions.xAxis.max = Math.round([
            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[1] ? this.favorite.ad_city.prix_commune_nb_piece.A[1].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[2] ? this.favorite.ad_city.prix_commune_nb_piece.A[2].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[3] ? this.favorite.ad_city.prix_commune_nb_piece.A[3].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[4] ? this.favorite.ad_city.prix_commune_nb_piece.A[4].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[5] ? this.favorite.ad_city.prix_commune_nb_piece.A[5].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[1] ? this.favorite.ad_city.prix_commune_nb_piece.M[1].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[2] ? this.favorite.ad_city.prix_commune_nb_piece.M[2].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[3] ? this.favorite.ad_city.prix_commune_nb_piece.M[3].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[4] ? this.favorite.ad_city.prix_commune_nb_piece.M[4].pM : 0,
            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[5] ? this.favorite.ad_city.prix_commune_nb_piece.M[5].pM : 0,
            this.favorite.total_price / this.favorite.square
        ].sort((a, b) => b - a)[0] / 1);

        if (estateType === 'Maison') {
            this.priceData = {
                series: [
                    {
                        name: 'Maison',
                        type: 'bar',
                        stack: '1',
                        data: [
                            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[1] ? this.favorite.ad_city.prix_commune_nb_piece.M[1].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[2] ? this.favorite.ad_city.prix_commune_nb_piece.M[2].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[3] ? this.favorite.ad_city.prix_commune_nb_piece.M[3].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[4] ? this.favorite.ad_city.prix_commune_nb_piece.M[4].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[5] ? this.favorite.ad_city.prix_commune_nb_piece.M[5].pM : null,
                            this.favorite.ad_city.prix_commune.A.pM,
                            this.favorite.ad_city.prix_commune.M.pM,
                        ]
                    }
                ]
            };

            this.priceOptions.yAxis.data = [this.favorite.ad_city.zip_code].concat(this.priceOptions.yAxis.data);
            this.priceData.series[0].data = [this.favorite.ad_city.prix_commune.B.pM.toPrecision(3)].concat(this.priceData.series[0].data);
        } else {
            this.priceData = {
                series: [
                    {
                        name: 'Appartement',
                        type: 'bar',
                        stack: '1',
                        data: [
                            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[1] ? this.favorite.ad_city.prix_commune_nb_piece.A[1].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[2] ? this.favorite.ad_city.prix_commune_nb_piece.A[2].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[3] ? this.favorite.ad_city.prix_commune_nb_piece.A[3].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[4] ? this.favorite.ad_city.prix_commune_nb_piece.A[4].pM : null,
                            this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[5] ? this.favorite.ad_city.prix_commune_nb_piece.A[5].pM : null,
                            this.favorite.ad_city.prix_commune.A.pM,
                            this.favorite.ad_city.prix_commune.M.pM,
                        ]
                    },
                ]
            };

            this.priceOptions.yAxis.data = [this.favorite.ad_city.name].concat(this.priceOptions.yAxis.data);
            this.priceData.series[0].data = [this.favorite.ad_city.prix_commune.B.pM.toPrecision(3)].concat(this.priceData.series[0].data);
        }

        this.priceOptions.yAxis.data.push('Votre projet');
        this.priceData.series.push(
            {
                name: 'Votre projet',
                type: 'bar',
                stack: '1',
                data: [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0, // One more for the city
                    (this.favorite.total_price / this.favorite.square).toPrecision(4),
                ]
            });

        if (this.priceEchartsIntance) {
            this.priceEchartsIntance.setOption(this.priceOptions);
        }
    }

    setPriceEvolData() {

        if (this.favorite.ad_city.city_code === '') {
            return;
        }

        const dataAville = [];
        const dataMville = [];

        this.priceEvolOptions.xAxis.data = PRICE_EVOL_LEGENT;
        this.priceEvolOptions.xAxis.data.forEach(keys => {

            if (this.favorite.ad_city.prix_ville.A != null && this.favorite.ad_city.prix_ville.A[keys] !== undefined) {
                dataAville.push(this.favorite.ad_city.prix_ville.A[keys].pM);
                if (this.priceEvolOptions.yAxis.min > (this.favorite.ad_city.prix_ville.A[keys].pM * 0.8)) {
                    this.priceEvolOptions.yAxis.min = Math.round(this.favorite.ad_city.prix_ville.A[keys].pM * 0.8 / 100) * 100;
                }
            } else {
                dataAville.push('');
            }

            if (this.favorite.ad_city.prix_ville.M != null && this.favorite.ad_city.prix_ville.M[keys] !== undefined) {
                dataMville.push(this.favorite.ad_city.prix_ville.M[keys].pM);
                if (this.priceEvolOptions.yAxis.min > (this.favorite.ad_city.prix_ville.M[keys].pM * 0.8)) {
                    this.priceEvolOptions.yAxis.min = Math.round(this.favorite.ad_city.prix_ville.M[keys].pM * 0.8 / 100) * 100;
                }
            } else {
                dataMville.push('');
            }
        });

        this.priceEvolData.series.push({
            name: this.favorite.ad_city.name + ' : Appartement',
            type: 'line',
            data: dataAville
        });

        this.priceEvolData.series.push({
            name: this.favorite.ad_city.name + ' : Maison',
            type: 'line',
            data: dataMville
        });
    }

    setChargeData() {
        this.chargeData = {
            series: [
                {
                    right: '20%',
                    name: '',
                    type: 'pie',
                    radius: ['60%', '90%'],
                    avoidLabelOverlap: false,
                    fontSize: 30,
                    itemStyle: {
                        borderRadius: 10,
                        borderColor: '#fff',
                        borderWidth: 2
                    },
                    label: {
                        show: true,
                        fontSize: 16,
                        alignTo: 'edge',
                        formatter: function(param) {
                            if (param.data.value > 0) {
                                return param.data.name + ' : ' + param.data.value + ' €';
                            }
                            return '';
                        },
                        minMargin: 5,
                        edgeDistance: 10,
                        lineHeight: 15,
                    },
                    labelLine: {
                        show: true
                    },
                    labelLayout: function(params) {
                        if (params.text == '') {
                            return {};
                        }
                        const isLeft = params.labelRect.x < 800 / 2;
                        const points = params.labelLinePoints;
                        // Update the end point.
                        points[2][0] = isLeft
                            ? params.labelRect.width + 20
                            : params.labelRect.x - 10;
                        return {
                            labelLinePoints: points
                        };
                    },
                    data: [
                        {value: Math.round(this.favorite.monthly), name: 'Mensualité'},
                        {value: Math.round(this.favorite.amount_property_tax / 12), name: 'Taxe foncière'},
                        {value: Math.round(this.favorite.agence_rental / 12 + (this.favorite.agence * this.favorite.amount_rent) / 100), name: 'Gestion en agence'},
                        {value: Math.round(this.favorite.amount_copro / 12), name: 'Charges de copro'},
                        {value: Math.round(this.favorite.building_insurance / 12), name: 'Assurance PNO'},
                        {value: Math.round((this.favorite.cash_flow > 0) ? this.favorite.cash_flow : 0), name: 'Cash flow'},
                    ]
                }
            ]
        };

        if (this.favorite.other_bill > 0) {
            this.chargeData.series[0].data.push({value: Math.round(this.favorite.other_bill / 12), name: 'Autres frais'});
        }
        if (this.favorite.accouting_fees + this.favorite.cfe_contribution > 0) {
            this.chargeData.series[0].data.push({value: Math.round((this.favorite.accouting_fees + this.favorite.cfe_contribution) / 12), name: 'Frais de comptabilité'});
        }
    }

    setEntrepriseEvolData() {
        Object.keys(this.favorite.ad_city.ets).forEach(keys => {
            if (this.entrepriseEvolOptions.yAxis.min > (this.favorite.ad_city.ets[keys] * 0.8)) {
                this.entrepriseEvolOptions.yAxis.min = Math.round(this.favorite.ad_city.ets[keys] * 0.8 / 100) * 100;
            }
        });

        if (this.favorite.ad_city.city_code === '') {
            return;
        }

        this.entrepriseEvolData = {
            series: [
                {
                    name: 'Nombre d\'entreprises',
                    type: 'line',
                    data: [this.favorite.ad_city.ets.ETNTOT14, this.favorite.ad_city.ets.ETNTOT15, this.favorite.ad_city.ets.ETNTOT16,
                        this.favorite.ad_city.ets.ETNTOT17, this.favorite.ad_city.ets.ETNTOT18, this.favorite.ad_city.ets.ETNTOT19,
                        this.favorite.ad_city.ets.ETNTOT20, this.favorite.ad_city.ets.ETNTOT21, this.favorite.ad_city.ets.ETNTOT22,
                        this.favorite.ad_city.ets.ETNTOT23]
                },
            ]
        };

        this.entrepriseEvolOptions.xAxis.data = ['2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023'];
    }

    setHabitantEvolData() {

        this.habitantEvolOptions.yAxis.min = 1000000;
        this.habitantEvolOptions.xAxis.data = [];

        const dataPop = [];
        Object.keys(this.favorite.ad_city.demographie_annuelle).forEach(keys => {
            if (keys !== 'Cr') {
                dataPop.push(this.favorite.ad_city.demographie_annuelle[keys]);
                this.habitantEvolOptions.xAxis.data.push(keys);
                if (this.habitantEvolOptions.yAxis.min > (this.favorite.ad_city.demographie_annuelle[keys] * 0.9)) {
                    this.habitantEvolOptions.yAxis.min = Math.round(this.favorite.ad_city.demographie_annuelle[keys] * 0.9 / 1000 - 1) * 1000;
                }
            }
        });
        this.habitantEvolData = {
            series: [
                {
                    // animation: false,
                    name: this.favorite.ad_city.name,
                    type: 'bar',
                    data: dataPop,
                },
            ]
        };
    }

    callImpot() {

        this.favorite = this.adService.cleanInput(this.favorite);
        this.favorite = this.adService.updateValues(this.favorite);

        const fav = this.adService.cleanForImpot(this.favorite, this.user);
        if (fav.fiscal_choice !== '' && fav.price > 0) {
            fav.is_credit_differed = false;
            this.http.post<any>(environment.impotUrl, fav)
                .subscribe(data => {
                    if (data[fav.fiscal_choice].cols !== undefined) {

                        // Graphique compraison des régimes fiscaux
                        this.result = data[fav.fiscal_choice].impots;

                        // 5 dernier + X premier
                        // if (this.result.length > 19) {
                        //     this.result = this.result.slice(0, 19 - 5).concat(this.result.slice(this.result.length - 5, this.result.length));
                        // }

                        if (this.result[this.result.length - 1].loyers_percus > 99999 || this.favorite.total_price > 999999) {
                            this.hideUnit = true;
                        }

                        let colums = this.favorite.fiscal_choice;
                        if (colums == 'Societe IS') {
                            colums = 'SCI IS';
                        }

                        if (this.favorite.selling == false) {
                            this.displayedColumns = data[colums].cols_simple;
                        } else {
                            this.displayedColumns = data[colums].cols_revente_simple;
                        }

                        // Graphique Evolution du capital net
                        const data_CF_cum = [];
                        const data_Amortissement = [];
                        const data_Enrich = [];

                        var cumul = 0;
                        Object.keys(this.result).forEach(keys => {
                            if (parseInt(keys, 10) < this.favorite.duration) {
                                cumul = cumul + Math.round(this.result[keys].cash_flow);
                                data_CF_cum.push(cumul);

                                data_Amortissement.push(Math.round(this.favorite.total_price - this.favorite.apport - this.result[keys].capital_restant_du));
                                data_Enrich.push(Math.round(this.favorite.total_price - this.favorite.apport - this.result[keys].capital_restant_du) + cumul);

                                this.amort_moy = Math.round((this.favorite.total_price - this.result[keys].capital_restant_du) / this.favorite.duration);
                            }
                        });

                        this.options_Evol_Capital.xAxis = [
                            {
                                type: 'category',
                                name: 'Année',
                                nameLocation: 'center',
                                nameTextStyle: {
                                    align: 'center',
                                    lineHeight: 50,
                                    fontWeight: 'bold',
                                    fontSize: 18
                                },
                                axisLabel: {
                                    fontSize: 16,
                                },
                                data: Array.from({length: this.favorite.duration}, (_, i) => i + 1)
                            }
                        ];

                        this.options_Evol_Capital.series = [
                            {
                                type: 'line',
                                lineStyle: {
                                    width: 3
                                },
                                symbolSize: 12,
                                name: 'Trésorerie cumulée',
                                color: '#67C2EF',
                                data: data_CF_cum
                            },
                            {
                                type: 'line',
                                lineStyle: {
                                    width: 3
                                },
                                symbolSize: 12,
                                name: 'Capital remboursé',
                                color: '#FABB3D',
                                data: data_Amortissement
                            },
                            {
                                type: 'line',
                                lineStyle: {
                                    width: 3
                                },
                                symbolSize: 12,
                                name: 'Enrichissement total',
                                color: '#78C447',
                                data: data_Enrich
                            },

                        ];
                        this.capitalData.series = this.options_Evol_Capital.series;

                        // Graphique évolution du Cash Flow
                        const dataCharges = [];
                        const dataLoyers = [];
                        const dataCF = [];
                        const dataPS = [];
                        const dataImpots = [];
                        const dataCredit = [];
                        const dataCS = [];

                        Object.keys(this.result).forEach(keys => {
                            dataCF.push(Math.round(this.result[keys].cash_flow));
                            dataLoyers.push(Math.round(this.result[keys].loyers_percus));
                            dataPS.push(Math.round(this.result[keys].prelev_sociaux));
                            dataCredit.push(Math.round(this.result[keys].annuite));
                            if (fav.fiscal_choice === 'SCI IS') {
                                dataImpots.push(Math.round(this.result[keys].impot_societes));
                                dataCharges.push(Math.round(-(this.result[keys].loyers_percus - this.result[keys].cash_flow + this.result[keys].impot_societes + this.result[keys].annuite)));
                            } else if (fav.fiscal_choice == 'LMP - regime reel') {
                                dataImpots.push(Math.round(this.result[keys].impots_revenus));
                                dataCharges.push(Math.round(-(this.result[keys].loyers_percus - this.result[keys].cash_flow + this.result[keys].prelev_sociaux + this.result[keys].impots_revenus + this.result[keys].annuite + this.result[keys].cotisations_sociales)));
                                dataCS.push(Math.round(this.result[keys].cotisations_sociales));
                            } else {
                                dataImpots.push(Math.round(this.result[keys].impots_revenus));
                                dataCharges.push(Math.round(-(this.result[keys].loyers_percus - this.result[keys].cash_flow + this.result[keys].prelev_sociaux + this.result[keys].impots_revenus + this.result[keys].annuite)));
                            }
                        });
                        // Graphique évolution du Cash Flow
                        var series = [
                            {
                                type: 'bar',
                                name: 'Loyers',
                                color: '#78C447',
                                stack: 'stack',
                                barWidth: 20,
                                data: dataLoyers,
                                lineStyle: {},
                                symbolSize: 0,
                            },
                            {
                                type: 'bar',
                                name: 'Charges',
                                color: '#9C9C9C',
                                stack: 'stack',
                                barWidth: 20,
                                data: dataCharges,
                            },
                            {
                                type: 'bar',
                                name: 'Crédit',
                                color: '#FABB3D',
                                stack: 'stack',
                                barWidth: 20,
                                data: dataCredit,
                            },
                            {
                                type: 'bar',
                                name: 'Impôts',
                                color: '#EB2D2D',
                                stack: 'stack',
                                barWidth: 20,
                                data: dataImpots,
                            },
                            {
                                type: 'bar',
                                name: 'Prélévements sociaux',
                                color: '#FF7777',
                                stack: 'stack',
                                barWidth: 20,
                                data: dataPS,
                            },
                        ];

                        if (fav.fiscal_choice == 'LMP - regime reel') {
                            series.push(
                                {
                                    type: 'bar',
                                    name: 'Cotisations sociales',
                                    color: '#e7abab',
                                    stack: 'stack',
                                    barWidth: 20,
                                    data: dataCS,
                                })
                        }

                        series.push({
                            type: 'line',
                            lineStyle: {
                                width: 3
                            },
                            symbolSize: 12,
                            name: 'Cash-Flow',
                            color: '#67C2EF',
                            data: dataCF,
                            stack: '',
                            barWidth: 0,
                        });

                        this.cashflowData.series = series
                    }

                    setTimeout(function() {
                        this.ready = true;
                    }.bind(this), 5000);

                }, err => {
                    console.log(err);
                });

            fav.rate = this.favorite.rate_second / 100;
            fav.duration = 25;
            if (fav.rate === 0) {
                this.monthly25 = Math.round(this.favorite.loaning / ( fav.duration * 12) + this.favorite.rate_insurance * (this.favorite.loaning / 100) / 12);
            } else {
                this.monthly25 = Math.round(
                    (this.favorite.loaning * ((this.favorite.rate_second/ 100) / 12)) / (1 - Math.pow(1 + ((this.favorite.rate_second/ 100) / 12), -1 * ( fav.duration * 12)))
                    + this.favorite.rate_insurance * (this.favorite.loaning / 100) / 12);
            }

            this.http.post<any>(environment.impotUrl, fav)
                .subscribe(data => {
                    if (data[fav.fiscal_choice].cols !== undefined) {

                        this.result25 = data[fav.fiscal_choice].impots;

                        if (this.result25[this.result25.length - 1].loyers_percus > 99999 || this.favorite.total_price > 999999) {
                            this.hideUnit = true;
                        }

                        let colums = this.favorite.fiscal_choice;
                        if (colums == 'Societe IS') {
                            colums = 'SCI IS';
                        }

                        if (this.favorite.fiscal_detailed_view == true) {
                            if (this.favorite.selling == false) {
                                this.displayedColumns = data[colums].cols;
                            } else {
                                this.displayedColumns = data[colums].cols_revente;
                            }
                        } else {
                            if (this.favorite.selling == false) {
                                this.displayedColumns = data[colums].cols_simple;
                            } else {
                                this.displayedColumns = data[colums].cols_revente_simple;
                            }
                        }

                        // Graphique Evolution du capital net
                        const data_CF_cum = [];
                        const data_Amortissement = [];
                        const data_Enrich = [];

                        var cumul = 0;
                        Object.keys(this.result25).forEach(keys => {
                            if (parseInt(keys, 10) < fav.duration) {
                                cumul = cumul + Math.round(this.result25[keys].cash_flow);
                                data_CF_cum.push(cumul);

                                data_Amortissement.push(Math.round(this.favorite.total_price - this.favorite.apport - this.result25[keys].capital_restant_du));
                                data_Enrich.push(Math.round(this.favorite.total_price - this.favorite.apport - this.result25[keys].capital_restant_du) + cumul);

                                this.amort_moy25 = Math.round((this.favorite.total_price - this.result25[keys].capital_restant_du) / fav.duration);
                            }
                        });

                        this.options_Evol_Capital25.xAxis = [
                            {
                                type: 'category',
                                name: 'Année',
                                nameLocation: 'center',
                                nameTextStyle: {
                                    align: 'center',
                                    lineHeight: 50,
                                    fontWeight: 'bold',
                                    fontSize: 18
                                },
                                axisLabel: {
                                    fontSize: 16,
                                },
                                data: Array.from({length: fav.duration}, (_, i) => i + 1)
                            }
                        ];

                        this.options_Evol_Capital25.series = [
                            {
                                type: 'line',
                                lineStyle: {
                                    width: 3
                                },
                                symbolSize: 12,
                                name: 'Trésorerie cumulée',
                                color: '#67C2EF',
                                data: data_CF_cum
                            },
                            {
                                type: 'line',
                                lineStyle: {
                                    width: 3
                                },
                                symbolSize: 12,
                                name: 'Capital remboursé',
                                color: '#FABB3D',
                                data: data_Amortissement
                            },
                            {
                                type: 'line',
                                lineStyle: {
                                    width: 3
                                },
                                symbolSize: 12,
                                name: 'Enrichissement total',
                                color: '#78C447',
                                data: data_Enrich
                            },

                        ];
                        this.capitalData25.series = this.options_Evol_Capital25.series;

                        // Graphique évolution du Cash Flow
                        const dataCharges = [];
                        const dataLoyers = [];
                        const dataCF = [];
                        const dataPS = [];
                        const dataImpots = [];
                        const dataCredit = [];
                        const dataCS = [];

                        Object.keys(this.result25).forEach(keys => {
                            dataCF.push(Math.round(this.result25[keys].cash_flow));
                            dataLoyers.push(Math.round(this.result25[keys].loyers_percus));
                            dataPS.push(Math.round(this.result25[keys].prelev_sociaux));
                            dataCredit.push(Math.round(this.result25[keys].annuite));
                            if (fav.fiscal_choice === 'SCI IS') {
                                dataImpots.push(Math.round(this.result25[keys].impot_societes));
                                dataCharges.push(Math.round(-(this.result25[keys].loyers_percus - this.result25[keys].cash_flow + this.result25[keys].impot_societes + this.result25[keys].annuite)));
                            } else if (fav.fiscal_choice == 'LMP - regime reel') {
                                dataImpots.push(Math.round(this.result25[keys].impots_revenus));
                                dataCharges.push(Math.round(-(this.result25[keys].loyers_percus - this.result25[keys].cash_flow + this.result25[keys].prelev_sociaux + this.result25[keys].impots_revenus + this.result25[keys].annuite + this.result25[keys].cotisations_sociales)));
                                dataCS.push(Math.round(this.result25[keys].cotisations_sociales));
                            }else {
                                dataImpots.push(Math.round(this.result25[keys].impots_revenus));
                                dataCharges.push(Math.round(-(this.result25[keys].loyers_percus - this.result25[keys].cash_flow + this.result25[keys].prelev_sociaux + this.result25[keys].impots_revenus + this.result25[keys].annuite)));
                            }
                        });
                        // Graphique évolution du Cash Flow
                        var series = [
                            {
                                type: 'bar',
                                name: 'Loyers',
                                color: '#78C447',
                                stack: 'stack',
                                barWidth: 20,
                                data: dataLoyers,
                                lineStyle: {},
                                symbolSize: 0,
                            },
                            {
                                type: 'bar',
                                name: 'Charges',
                                color: '#9C9C9C',
                                stack: 'stack',
                                barWidth: 20,
                                data: dataCharges,
                            },
                            {
                                type: 'bar',
                                name: 'Crédit',
                                color: '#FABB3D',
                                stack: 'stack',
                                barWidth: 20,
                                data: dataCredit,
                            },
                            {
                                type: 'bar',
                                name: 'Impôts',
                                color: '#EB2D2D',
                                stack: 'stack',
                                barWidth: 20,
                                data: dataImpots,
                            },
                            {
                                type: 'bar',
                                name: 'Prélévements sociaux',
                                color: '#FF7777',
                                stack: 'stack',
                                barWidth: 20,
                                data: dataPS,
                            },
                        ];

                        if (fav.fiscal_choice == 'LMP - regime reel') {
                            series.push(
                                {
                                    type: 'bar',
                                    name: 'Cotisations sociales',
                                    color: '#e7abab',
                                    stack: 'stack',
                                    barWidth: 20,
                                    data: dataCS,
                                })
                        }

                        series.push({
                            type: 'line',
                            lineStyle: {
                                width: 3
                            },
                            symbolSize: 12,
                            name: 'Cash-Flow',
                            color: '#67C2EF',
                            data: dataCF,
                            stack: '',
                            barWidth: 0,
                        });

                        this.cashflowData25.series = series;
                    }

                    setTimeout(function() {
                        this.ready = true;
                    }.bind(this), 5000);

                }, err => {
                    console.log(err);
                });
        } else {
            const champsManquants = [];
            if (fav.fiscal_choice === '') {
                champsManquants.push('le régime fiscal');
            }
            if (!(fav.price > 0)) {
                champsManquants.push('le prix');
            }
            this.alertService.error('Informations manquantes pour la fiscalité : ' + champsManquants.join(' et ') + '.');
        }
    }

    onRentChartInit(ec) {
        this.rentEchartsIntance = ec;
    }

    onPriceChartInit(ec) {
        this.priceEchartsIntance = ec;
    }

    onChargeChartInit(ec) {
        this.chargeEchartsIntance = ec;
    }

    onChartECInit(ec) {
        this.capitalEchartsIntance = ec;
    }

    onChartCFInit(ec) {
        this.cashflowEchartsIntance = ec;
    }

    onEntrepriseEvolInit(ec) {
        this.entrepriseEvolEchartsIntance = ec;
    }

    onHabitantEvolInit(ec) {
        this.habitantEvolEchartsIntance = ec;
    }

    edit(event, fields = '') {
        if (fields == 'description') {
            this.adService.updateFavoriteText(this.favorite, this.favorite.description, fields);
        } else if (fields == 'comment_city') {
            this.adService.updateFavoriteText(this.favorite, this.favorite.comment_city, fields);
        } else if (fields == 'comment') {
            this.adService.updateFavoriteText(this.favorite, this.favorite.comment, fields);
        } else if (fields == 'comment_work') {
            this.adService.updateFavoriteText(this.favorite, this.favorite.comment_work, fields);
        } else if (fields == 'pictures') {
            this.favorite.pictures_number = this.nbPictures_1 + ';' + this.nbPictures_2 + ';' + this.nbPictures_3 + ';' + this.nbPictures_4 + ';' + this.nbPictures_5 + ';' + this.nbPictures_6;
            this.adService.updateFavoriteText(this.favorite, this.favorite.pictures_number, fields);
        }
    }

    onPageChange(val) {
        if (_.difference(val, this.user.user_dashboard.pdf_page).length !== 0) {
            // Checked
            this.user.user_dashboard.pdf_page = _.without(this.user.user_dashboard.pdf_page, 'action');
            this.user.user_dashboard.pdf_page.push(_.difference(val, this.user.user_dashboard.pdf_page)[0]);
        } else if (_.difference(this.user.user_dashboard.pdf_page, val).length !== 0) {
            // Unchecked
            this.user.user_dashboard.pdf_page = _.without(this.user.user_dashboard.pdf_page, _.difference(this.user.user_dashboard.pdf_page, val)[0]);
        }
        this.updateDashboard();
    }

    updateDashboard() {
        this.userService.updateDashboard(this.user);
    }

    protected readonly EVOL_DEMO_LAST_YEAR = EVOL_DEMO_LAST_YEAR;
}
